// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.member-list-container {
  overflow-x: hidden;
}
.invite-button {
  color: white;
  border: none;
  padding: 10px;
  border-radius: 18px;
  display: flex;
  flex-direction: row;
  justify-content: center !important;
  align-items: center;
  outline: none !important;
  transition: background-color 0.3s;
}
.invite-member-container {
  margin-bottom: 10px !important;
  margin-top: 10px !important;
}
.invite-member-heading{
  font-size: 20px;
  font-weight: 700;
}
.profile-picture {
  margin-right: 15px !important;
  margin-left: 5px !important;
  height: 40px !important;
  width: 40px !important;
  border-radius: 50px !important;
}

.invite-button.enabled {
  background: linear-gradient(to left, #1976d2, #1e88e5, #98b9d8);
  cursor: pointer;
}

.slick-slider {
  border: solid 1px #dee0e1;
  padding: 10px 20px;
  border-radius: 20px;
  background: #ffffff; /* Default background */
}

.homePageStyle {
  background: #efeeed !important; /* Apply this background for homePage */
}

.invite-button.disabled {
  background-color: #98b9d8;
  cursor: not-allowed !important;
}
.community-image-container{
  position: relative;
}
.community-card-img{
  width: 100%;
  height: 12.5vh;
  border-radius: 15px;
}
.crown-symbol-in-community-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 25px;
  height: 25px;
  margin-left: 6px;
  margin-top: 6px;
}

.search-bar {
  border-radius: 25px;
  background-color: #ffffff !important;
  height: 48px;
  margin-top: -1px;
  outline: none !important;
  width: 93.8% !important;
  margin-left: 5px;
}
.searchBar {
  border-radius: 25px;
  background-color: #ffffff !important;
  height: 48px;
  margin-top: 3px;
  outline: none !important;
  width: 90%; /* ideal width for large screens */
  max-width: 800px; /* prevent being too wide */
  min-width: 200px; /* prevent collapse */
  padding: 0 16px;
  border: 1px solid #ccc;
  font-size: 15px;
  box-sizing: border-box;
  transition: all 0.3s ease;
  margin-left: 5px;
}

/* Slight visual improvement on focus */
.searchBar:focus {
  border-color: #0078ff;
  box-shadow: 0 0 6px rgba(0, 120, 255, 0.3);
}

/* Tablet and smaller screens */
@media (max-width: 900px) {
  .searchBar {
    width: 90%; /* expand inside smaller modal */
    height: 46px;
    font-size: 14px;
    margin-top: 8px;
  }
}

/* Mobile view */
@media (max-width: 600px) {
  .searchBar {
    width: 85%; /* ensures it fits perfectly within map area */
    height: 44px;
    font-size: 13px;
    padding: 0 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/components/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,wBAAwB;EACxB,iCAAiC;AACnC;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,+DAA+D;EAC/D,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB,EAAE,uBAAuB;AAC9C;;AAEA;EACE,8BAA8B,EAAE,uCAAuC;AACzE;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,UAAU,EAAE,kCAAkC;EAC9C,gBAAgB,EAAE,2BAA2B;EAC7C,gBAAgB,EAAE,qBAAqB;EACvC,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU,EAAE,gCAAgC;IAC5C,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,UAAU,EAAE,8CAA8C;IAC1D,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;AACF","sourcesContent":[".member-list-container {\r\n  overflow-x: hidden;\r\n}\r\n.invite-button {\r\n  color: white;\r\n  border: none;\r\n  padding: 10px;\r\n  border-radius: 18px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center !important;\r\n  align-items: center;\r\n  outline: none !important;\r\n  transition: background-color 0.3s;\r\n}\r\n.invite-member-container {\r\n  margin-bottom: 10px !important;\r\n  margin-top: 10px !important;\r\n}\r\n.invite-member-heading{\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n}\r\n.profile-picture {\r\n  margin-right: 15px !important;\r\n  margin-left: 5px !important;\r\n  height: 40px !important;\r\n  width: 40px !important;\r\n  border-radius: 50px !important;\r\n}\r\n\r\n.invite-button.enabled {\r\n  background: linear-gradient(to left, #1976d2, #1e88e5, #98b9d8);\r\n  cursor: pointer;\r\n}\r\n\r\n.slick-slider {\r\n  border: solid 1px #dee0e1;\r\n  padding: 10px 20px;\r\n  border-radius: 20px;\r\n  background: #ffffff; /* Default background */\r\n}\r\n\r\n.homePageStyle {\r\n  background: #efeeed !important; /* Apply this background for homePage */\r\n}\r\n\r\n.invite-button.disabled {\r\n  background-color: #98b9d8;\r\n  cursor: not-allowed !important;\r\n}\r\n.community-image-container{\r\n  position: relative;\r\n}\r\n.community-card-img{\r\n  width: 100%;\r\n  height: 12.5vh;\r\n  border-radius: 15px;\r\n}\r\n.crown-symbol-in-community-card {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 25px;\r\n  height: 25px;\r\n  margin-left: 6px;\r\n  margin-top: 6px;\r\n}\r\n\r\n.search-bar {\r\n  border-radius: 25px;\r\n  background-color: #ffffff !important;\r\n  height: 48px;\r\n  margin-top: -1px;\r\n  outline: none !important;\r\n  width: 93.8% !important;\r\n  margin-left: 5px;\r\n}\r\n.searchBar {\r\n  border-radius: 25px;\r\n  background-color: #ffffff !important;\r\n  height: 48px;\r\n  margin-top: 3px;\r\n  outline: none !important;\r\n  width: 90%; /* ideal width for large screens */\r\n  max-width: 800px; /* prevent being too wide */\r\n  min-width: 200px; /* prevent collapse */\r\n  padding: 0 16px;\r\n  border: 1px solid #ccc;\r\n  font-size: 15px;\r\n  box-sizing: border-box;\r\n  transition: all 0.3s ease;\r\n  margin-left: 5px;\r\n}\r\n\r\n/* Slight visual improvement on focus */\r\n.searchBar:focus {\r\n  border-color: #0078ff;\r\n  box-shadow: 0 0 6px rgba(0, 120, 255, 0.3);\r\n}\r\n\r\n/* Tablet and smaller screens */\r\n@media (max-width: 900px) {\r\n  .searchBar {\r\n    width: 90%; /* expand inside smaller modal */\r\n    height: 46px;\r\n    font-size: 14px;\r\n    margin-top: 8px;\r\n  }\r\n}\r\n\r\n/* Mobile view */\r\n@media (max-width: 600px) {\r\n  .searchBar {\r\n    width: 85%; /* ensures it fits perfectly within map area */\r\n    height: 44px;\r\n    font-size: 13px;\r\n    padding: 0 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
